export default __webpack_public_path__ + "static/media/x-icon-white.0d76fdc3.svg";